import * as types from "../types/notification.types";
import { 
  getNotificationList,
  getNotificationSingle,
  postNotificationAdd,
  getCategoriesList,
  getCategoriesSingle,
  patchCategoriesEdit,
  postCategoriesAdd,
  deleteCategoriesDelete,
} from '../../services/notification.service';
import { validationErrors } from "../../utils/Helpers";
import { successAlert } from "../../components/alret/notificztion";


// Notification Action
// Get List
export const getNotificationAction = (data) => {
  return async (dispatch, getState)  => {
    try {
      await getNotificationList(getState().authReducer.token, getState().authReducer.user.id, data).then((res) => {
        if(res.data.code === 200){
          dispatch({type: types.SET_NOTIFICATION_LIST_DATA, payload: res.data.data});
          dispatch({type: types.SET_NOTIFICATION_LIST_PAGINATION, payload: res.data.pagination});
        }
      });
    } catch (e) {validationErrors(e)}
  };
};

// Get List Filter
export const filterNotificationAction = (data) => {
  return async (dispatch) => {
    dispatch({type: types.SET_NOTIFICATION_LIST_FILTER, payload: data});
  };
};

// Get Single
export const singleNotificationsAction = (id) => {
  return async (dispatch, getState) => {
    try {
      await getNotificationSingle(getState().authReducer.token, getState().authReducer.user.id, id).then((res) => {
        dispatch({type: types.SET_NOTIFICATION_VIEW_DATA, payload: res.data.data});
      })
    } catch (e) {validationErrors(e)}
  };
};

// Add data
export const postNotificationAction = (data) => {
  return async (dispatch, getState) => {
    try {
      await postNotificationAdd(getState().authReducer.token, getState().authReducer.user.id, data).then((res)=>{
        successAlert(res.data.message)
      })
    } catch (e) {validationErrors(e)}
  };
};





// Categories Action
// Get List
export const getCategoriesAction = (data) => {
  return async (dispatch, getState)  => {
    try {
      await getCategoriesList(getState().authReducer.token, getState().authReducer.user.id, data).then((res) => {
        if(res.data.code === 200){
          dispatch({type: types.SET_CATEGORIES_LIST_DATA, payload: res.data.data,});
          dispatch({type: types.SET_CATEGORIES_LIST_PAGINATION, payload: res.data.pagination,});
        }
      });
    } catch (e) {validationErrors(e);}
  };
};

// Get List Filter
export const filterCategoriesAction = (data) => {
  return async (dispatch) => {
    dispatch({type: types.SET_CATEGORIES_LIST_FILTER, payload: data});
  };
};

// Get Single
export const singleCategoriesAction = (id) => {
  return async (dispatch, getState) => {
    try {
      await getCategoriesSingle(getState().authReducer.token, getState().authReducer.user.id, id).then((res) => {
        dispatch({type: types.SET_CATEGORIES_VIEW_DATA, payload: res.data.data});
      })
    } catch (e) {validationErrors(e)}
  };
};

// Update data
export const patchCategoriesAction = (data, id) => {
  return async (dispatch, getState) => {
    try {
      await patchCategoriesEdit(getState().authReducer.token, getState().authReducer.user.id, data, id).then((res)=>{successAlert(res.data.message)})
    } catch (e) {validationErrors(e)}
  };
};

// Add data
export const postCategoriesAction = (data) => {
  return async (dispatch, getState) => {
    try {
      await postCategoriesAdd(getState().authReducer.token, getState().authReducer.user.id, data).then((res)=>{successAlert(res.data.message)})
    } catch (e) {validationErrors(e)}
  };
};

// Delete data
export const deleteCategoriesAction = (id) => {
  return async (dispatch, getState) => {
    try {
      await deleteCategoriesDelete(getState().authReducer.token, getState().authReducer.user.id, id).then((res)=>{successAlert(res.data.message)})
    } catch (e) {validationErrors(e)}
  };
};